import React, {useState, useEffect} from "react";

import {Form} from "react-bootstrap";
import {useForm} from "react-hook-form";

import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";

import SingleInput from "./SingleInput";

function Register({setIsFirstStep, formState, setFormState}) {
  const schema = yup.object().shape({
    username: yup.string().required("Please choose a username."),
    email: yup
      .string()
      .email("Please use a valid email.")
      .required("Please choose an email."),
  });
  const {
    register,
    handleSubmit,
    formState: {errors, isDirty},
  } = useForm({
    defaultValues: {
      username: formState.username,
      email: formState.email,
    },
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const onSubmit = formValues => {
    setFormState(prev => ({...prev, ...formValues}));
    setIsFirstStep(false);
  };

  return (
    <Form sm={12} noValidate onSubmit={handleSubmit(onSubmit)}>
      <SingleInput
        label="Full Name"
        name={"username"}
        errors={errors}
        register={register}
        placeholder="Full Name"
      />
      <SingleInput
        label="Email"
        name={"email"}
        type="email"
        errors={errors}
        register={register}
        placeholder="Email"
      />

      <div className="form-group pt-2 pb-2">
        <button type="submit" className="btn btn-primary btn-block btn-full">
          Next
        </button>
      </div>
    </Form>
  );
}

export default Register;
